type LocaleSelectableLanguage = {
    language: string;
    locale: string;
};

type LocaleSelectableHost = {
    countryCode: string;
    languages: LocaleSelectableLanguage[];
};

function normalizeLocale(locale: string): string {
    return locale.replace('_', '-').toLowerCase();
}

export function languageCodeFromLocale(locale: string): string {
    return locale.replace('_', '-').split('-')[0] ?? '';
}

export function withForcedLocalePrefix(pathname: string, prefix: string): string {
    const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
    return `/${prefix}${path}`;
}

export function findHostAndLanguageForLocale<THost extends LocaleSelectableHost>(
    hosts: THost[],
    currentLocale: string,
): {host: THost | undefined; language: THost['languages'][number] | undefined} {
    const normalizedLocale = normalizeLocale(currentLocale);
    const languageCode = languageCodeFromLocale(currentLocale);
    const countryCode = currentLocale.replace('_', '-').split('-')[1];

    const host =
        hosts.find((candidate) => candidate.languages.some((language) => normalizeLocale(language.locale) === normalizedLocale)) ??
        hosts.find((candidate) => candidate.countryCode === (countryCode ?? '')) ??
        hosts[0];

    const language =
        host?.languages.find((candidate) => normalizeLocale(candidate.locale) === normalizedLocale) ??
        host?.languages.find((candidate) => candidate.language === languageCode) ??
        host?.languages[0];

    return {host, language};
}
